module.exports = __webpack_public_path__ + "static/media/package_updater.9fd75897.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/package_updater.png
// module id = 73
// module chunks = 0